export const typedObjectKeys = <T extends object>(obj: T): Array<keyof T> => {
  return Object.keys(obj) as Array<keyof T>;
};

export const typedObjectValues = <T extends object>(
  obj: T,
): Array<T[keyof T]> => {
  return Object.values(obj) as Array<T[keyof T]>;
};
